import { Table, TableBody, Typography } from '@sanlam-glacier/app-common/components';
import styles from './internal-rate-of-return.module.scss';
import { TableHeader } from 'components/organisms/table';
import InternalRateOfReturnRow from './InternalRateOfReturnRow';
import { InternalRateOfReturnHeaderData } from './internal-rate-of-return.function';
import { InternalRateOfReturnProps } from 'modules/clients/types/transaction-summary';

const InternalRateOfReturnTable = ({ fromDate, toDate, gross, net }: InternalRateOfReturnProps) => {
  return (
    <div data-testid='transactionSummaryInternalRateOfReturnContainer' className={styles.container}>
      <div className={styles.heading}>
        <Typography data-testid='transactionSummaryInternalRateOfReturnHeading' variant={Typography.VARIANT.B2} weight={Typography.WEIGHT.MEDIUM}>
          Internal rate of return (IRR) for multiple periods:
        </Typography>
        <Typography data-testid='transactionSummaryInternalRateOfReturnPeriodDescription' variant={Typography.VARIANT.B2}>
          {`${fromDate} to ${toDate} & 1 year, 3 years, 5 years`}
        </Typography>
      </div>
      <Table data-testid={'case-tracking-table'}>
        <TableHeader
          data-testid={'headers'}
          headers={InternalRateOfReturnHeaderData}
          tableHeaderClassName={styles.tableHeaderContainer}
          hoverable={false}
        />
        <TableBody>
          <InternalRateOfReturnRow
            data-testid='transactionSummaryInternalRateOfReturnNetRow'
            internalRateOfReturn={net.internalRateOfReturn}
            tooltipContent={net.tooltipContent}
            specifiedPeriod={net.specifiedPeriod}
            oneYear={net.oneYear}
            threeYears={net.threeYears}
            fiveYears={net.fiveYears}
            testid='transactionSummaryNet'
          />
          <InternalRateOfReturnRow
            data-testid='transactionSummaryInternalRateOfReturnGrossRow'
            internalRateOfReturn={gross.internalRateOfReturn}
            tooltipContent={gross.tooltipContent}
            specifiedPeriod={gross.specifiedPeriod}
            oneYear={gross.oneYear}
            threeYears={gross.threeYears}
            fiveYears={gross.fiveYears}
            testid='transactionSummaryGross'
          />
        </TableBody>
      </Table>
    </div>
  );
};

export default InternalRateOfReturnTable;
